import React from "react";
import NewsList from "./List/NewsList";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const News = () => {
    return (
        <div className="list">
            <div className="listContainer">
                <NewsList />
            </div>
        </div>
    );
};

export default News;